// extracted by mini-css-extract-plugin
export default {"content":"Offer_content__21Tsi","text":"Offer_text__GMFnf","buttons":"Offer_buttons__qXb-K","placeHolderShimmer":"Offer_placeHolderShimmer__ssZ1M"};